// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ResultsFeedController {
   $timeout: any
   $window: any
   alerts: any
   appState: any
   feed: any
   searchScopeService:SearchScopeService
   constructor($scope: any, feed: any, appState: any, config: any, alerts: any, $window: any, $timeout: any, $sce: any,  searchScopeService: SearchScopeService) {
      this.retryPageRequest = this.retryPageRequest.bind(this)
      this.feed = feed
      this.appState = appState
      this.alerts = alerts
      this.$window = $window
      this.$timeout = $timeout
      $scope.feed = this.feed.scope
      $scope.searchScopeService = searchScopeService
      const resultsConfig = config.data.results
      $scope.displayCitationCounts = resultsConfig.displayCitationCounts
      $scope.displayResultCounts = resultsConfig.displayResultCounts
      $scope.displayPermalink = resultsConfig.displayPermalink
      $scope.retryPageRequest = this.retryPageRequest
      this.searchScopeService = searchScopeService

      // methods
      $scope.load = this.feed.loadMore
      $scope.templateFor = this.templateFor
      $scope.isDefaultScope = this.isDefaultScope

      // WARNING:
      //   There should only be ONE ResultsFeedCtrl initialized since having multiple
      //   can cause the page num to decrement multiple times on an 'apiError' event which
      //   would cause the reloading of previous pages.
      $scope.$on('apiError', (evt: any, msg: any) => {
      // decrement the page num on an API error during page load to prevent page skipping
         if (msg.isPageRequest && (this.appState.params.pn > 1)) {
            return this.appState.params.pn -= 1
         }
      })

      $scope.trustAsHtml = $sce.trustAsHtml
   }

   templateFor(item: any) {
      return `/assets/resultsFeed/${item.type}.html`
   }

   retryPageRequest() {
      return this.alerts.resetAlert('pageRequestError')
   }

   isDefaultScope(scopeName:string) {
      return this.searchScopeService.isDefaultScope(scopeName)
   }
}

ResultsFeedController.$inject = ['$scope', 'resultsFeedService', 'appStateService', 'configService', 'alertService', '$window', '$timeout', '$sce', 'searchScopeService']

angular.module('summonApp.controllers')
   .controller('ResultsFeedCtrl', ResultsFeedController)
